import '../index.css';import { jsx as e, jsxs as W, Fragment as vt } from "react/jsx-runtime";
import { faSchoolFlag as Kt } from "@fortawesome/pro-regular-svg-icons/faSchoolFlag";
import { faSuitcase as Vt } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faUser as Pt } from "@fortawesome/pro-solid-svg-icons/faUser";
import te from "@mui/material/Avatar";
import L from "classnames";
import { createTheme as ee, ThemeProvider as oe } from "@mui/material/styles";
import mt, { useState as ht, forwardRef as ne, useRef as re } from "react";
import { faCaretDown as ae } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { Tooltip as ie, Popover as Ut, Box as le, Typography as se } from "@mui/material";
import { faArrowDownToLine as ce } from "@fortawesome/pro-regular-svg-icons/faArrowDownToLine";
import { faLoader as de } from "@fortawesome/pro-regular-svg-icons/faLoader";
import { faLock as fe } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faPencil as ue } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faPlus as me } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faTrashCan as he } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { faArrowRight as ge } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faChevronDown as be } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronRight as pe } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { Link as Ct } from "react-router-dom";
import { dayjsLocalizer as ye, Calendar as _e } from "react-big-calendar";
import { faChevronLeft as Rt } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { FontAwesomeIcon as xe } from "@fortawesome/react-fontawesome";
import { faCircleMinus as we, faTriangleExclamation as ve, faHourglass as Se, faCircleCheck as ke } from "@fortawesome/pro-solid-svg-icons";
import Me from "@mui/material/IconButton";
import { faCircleCheck as $e } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleInfo as Ce } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faHandWave as De } from "@fortawesome/pro-regular-svg-icons/faHandWave";
import { faHourglassHalf as Le } from "@fortawesome/pro-regular-svg-icons/faHourglassHalf";
import { faLightbulbOn as We } from "@fortawesome/pro-regular-svg-icons/faLightbulbOn";
import { faOctagonExclamation as ze } from "@fortawesome/pro-regular-svg-icons/faOctagonExclamation";
import { faTriangleExclamation as Te } from "@fortawesome/pro-regular-svg-icons/faTriangleExclamation";
import { faXmark as Be } from "@fortawesome/pro-regular-svg-icons/faXmark";
import Gt from "react-spinkit";
import Fe from "@mui/material/Paper";
import V from "@mui/material/Skeleton";
import { faLoader as Oe } from "@fortawesome/pro-solid-svg-icons/faLoader";
import Ne from "@mui/material/TextField";
import Re from "@mui/material/InputAdornment";
import { faEye as He } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash as Ae } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import Lt from "@mui/material/useMediaQuery";
const Mt = {
  xxl: {
    width: 64,
    height: 64,
    icon: "2xl"
  },
  xl: {
    width: 56,
    height: 56,
    icon: "xl"
  },
  lg: {
    width: 48,
    height: 48,
    icon: "lg"
  },
  md: {
    width: 40,
    height: 40,
    /**
     * 'md' is not a valid size for FontAwesomeIcon.
     * When undefined is passed to FontAwesomeIcon as a size value,
     * the icon will default to the current font size of its parent element.
     */
    icon: void 0
  },
  sm: {
    width: 32,
    height: 32,
    icon: "sm"
  },
  xs: {
    width: 24,
    height: 24,
    icon: "xs"
  },
  xxs: {
    width: 16,
    height: 16,
    icon: "2xs"
  }
}, Ee = ({
  size: t = "md",
  children: o,
  fallback: r,
  alt: n
}) => {
  if (o)
    return o;
  switch (r) {
    case "person":
      return /* @__PURE__ */ e(B, { icon: Pt, size: Mt[t].icon, alt: n });
    case "school":
      return /* @__PURE__ */ e(
        B,
        {
          icon: Kt,
          size: Mt[t].icon,
          alt: n
        }
      );
    case "employer":
      return /* @__PURE__ */ e(B, { icon: Vt, size: Mt[t].icon, alt: n });
    default:
      return null;
  }
}, ni = ({
  children: t = void 0,
  fallback: o = "person",
  size: r = "md",
  ...n
}) => /* @__PURE__ */ e(te, { sx: Mt[r], ...n, children: Ee({ size: r, fallback: o, children: t, alt: n.alt }) }), Ht = {}, Ie = (t) => t.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/(\d)([a-zA-Z])/g, "$1 $2").replace(/([a-zA-Z])(\d)/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(/\s+/g, "-"), je = (t) => t.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(
  /(?:\s+|^)(\w)/g,
  (o, r, n) => n === 0 ? r : r.toUpperCase()
).replace(/\s+/g, ""), rt = {
  black: "#000",
  blackV2: "#1e1a12",
  white: "#fff",
  font: "#363636",
  brandClever: "#4271f6",
  brandOneroster: "#0f4d87",
  blue: "#4397ea",
  blueBg: "#f5fbff",
  blueDark: "#2386e7",
  blueXtraDark: "#1477d8",
  blueContrastDark: "#124577",
  blueExtraLight: "#e6f3fa",
  blueLight: "#c4e1f2",
  blueMedium: "#68aaee",
  blueSteel: "#728dac",
  blueSteelDark: "#5f7ea0",
  blueSteelXtraDark: "#516d8f",
  blueSteelContrastDark: "#3a4e66",
  blueSteelExtraLight: "#e8eff5",
  blueSteelLight: "#cbdaeb",
  blueSteelMedium: "#8da7c4",
  gray: "#999",
  grayBg: "#f6f6f6",
  grayDark: "#6f6f6f",
  grayDarkV2: "#71726e",
  grayXtraDark: "#595959",
  grayExtraLight: "#eee",
  grayLight: "#dbdbdb",
  grayMedium: "#bebdbd",
  green: "#5aa43d",
  greenBg: "#fbfff4",
  greenDark: "#429617",
  greenXtraDark: "#268900",
  greenContrastDark: "#1c6400",
  greenExtraLight: "#f1f6e6",
  greenLight: "#ddedc9",
  greenMedium: "#7db866",
  indigo: "#7180d6",
  indigoDark: "#5d6ed0",
  indigoXtraDark: "#5364c6",
  indigoContrastDark: "#394799",
  indigoExtraLight: "#e6e9f8",
  indigoLight: "#b7c3ff",
  indigoMedium: "#8c99e3",
  orange: "#ff8000",
  orangeDark: "#f07000",
  orangeXtraDark: "#d66000",
  orangeContrastDark: "#99430d",
  orangeExtraLight: "#feedd5",
  orangeLight: "#ffd9b8",
  orangeMedium: "#fc9b5f",
  purple: "#9974dc",
  purpleDark: "#8d64d8",
  purpleXtraDark: "#8861cf",
  purpleContrastDark: "#583cbd",
  purpleExtraLight: "#ede8f8",
  purpleLight: "#d9c4ff",
  purpleMedium: "#ae8fea",
  red: "#e46658",
  redDark: "#d85446",
  redXtraDark: "#d24536",
  redContrastDark: "#9e2518",
  redExtraLight: "#ffe9e9",
  redLight: "#ffb3ab",
  redMedium: "#f67c6f",
  teal: "#16a2a2",
  tealDark: "#149090",
  tealDarkV2: "#2b7383",
  tealXtraDark: "#128484",
  tealContrastDark: "#0a5656",
  tealExtraLight: "#e3f4f2",
  tealLight: "#cceaea",
  tealLightV2: "#ecf5f7",
  tealMedium: "#62bcbc",
  violet: "#c863d9",
  violetDark: "#c253d5",
  violetXtraDark: "#ba3dd0",
  violetContrastDark: "#752383",
  violetExtraLight: "#f5e9f7",
  violetLight: "#f6c8ff",
  violetMedium: "#d68ce3",
  pink: "#d85a8c",
  pinkDark: "#cc3e76",
  pinkXtraDark: "#ba2c65",
  pinkContrastDark: "#811d45",
  pinkExtraLight: "#ffebf3",
  pinkLight: "#ffcce0",
  pinkMedium: "#fbb1cf",
  yellow: "#fad961",
  yellowV2: "#f5ec1e",
  yellowDark: "#f5c614",
  yellowXtraDark: "#eebc04",
  yellowContrastDark: "#986f15",
  yellowContrastLight: "#ffffef",
  yellowExtraLight: "#fff7da",
  yellowLight: "#ffefb7",
  yellowLightV2: "#fbfbca",
  yellowMedium: "#fbdf78",
  yellowTextDark: "#b28d02"
}, Xe = {
  base: "'Halis Rounded', 'Segoe UI', 'HelveticaNeue-Light', 'Roboto', sans-serif",
  baseV2: "'GT Flexa', 'Segoe UI', 'HelveticaNeue-Light', 'Roboto', sans-serif",
  body: "'Roboto', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  code: "'Roboto Mono', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  signature: "'Sofia', cursive",
  emoji: "emoji"
}, Ye = {
  robotoLight: 300,
  robotoRegular: 400,
  robotoMedium: 500,
  robotoBold: 700,
  robotoBlack: 900,
  halisThin: 100,
  halisLight: 300,
  halisBook: 400,
  halisRegular: 500,
  halisMedium: 600,
  halisBold: 700,
  halisBlack: 800
}, Ue = {
  iconXxs: "10px",
  iconXs: "12px",
  iconXtSm: "14px",
  iconSm: "16px",
  iconMd: "20px",
  iconLg: "24px",
  iconXl: "32px",
  iconXxl: "40px",
  fontSizeTitleLg: "64px",
  fontSizeTitle: "26px",
  fontSizeTitleSm: "24px",
  fontSizeTitleXs: "22px",
  fontSizeLg: "20px",
  fontSizeMd: "18px",
  fontSizeSm: "16px",
  fontSizeXs: "14px",
  fontSizeXxs: "12px",
  fontSizeXxxs: "10px",
  fontSizeEmoji: "32px",
  appbarHeight: "64px",
  sidebarWidth: "64px",
  subnavHeight: "48px",
  containerBorderWidth: "2px",
  containerBorderRadiusLarge: "32px",
  containerBorderRadiusMedium: "16px",
  containerBorderRadius: "8px",
  containerBorderRadiusXtSmall: "6px",
  containerBorderRadiusSmall: "4px",
  containerBorderRadiusTop: "8px 8px 0 0",
  containerBorderRadiusBottom: "0 0 8px 8px",
  containerBorderRadiusLeft: "8px 0 0 8px",
  containerBorderRadiusRight: "0 8px 8px 0",
  containerBorderRadiusTopLeft: "8px 0 0 0",
  containerBorderRadiusTopRight: "0 8px 0 0",
  containerBorderRadiusBottomLeft: "0 0 0 8px",
  containerBorderRadiusBottomRight: "0 0 8px 0",
  contentHeight: "calc(100vh - 64px)",
  chatBorderRadiusTopLeft: "2px 16px 16px 16px",
  shadow: "0 2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowTop: "0 -2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowExtraLight: "0 1px 5px rgba(0, 0, 0, 0.12)",
  shadowLight: "0 0 5px 0 rgba(0, 0, 0, 0.15)",
  shadowMedium: "0 4px 12px rgba(0, 0, 0, 0.3)",
  shadowStrong: "0 2px 60px 0 rgba(0, 0, 0, 0.2)",
  shadowInset: "inset 0 0 5px 0 rgba(0, 0, 0, 0.1)",
  shadowBottom: "0px 10px 10px -6px rgba(0, 0, 0, 0.15)",
  shadowBlue: "0px 0px 0px 2px rgba(18, 69, 119, 0.40)",
  shadowGray: "0px 0px 0px 2px rgba(190, 189, 189, 0.40)",
  shadowRed: "0px 0px 0px 2px rgba(158, 37, 24, 0.40)",
  shadowFont: "0px 2px 0px 0px #363636"
}, Ge = {
  tt: "1px",
  tiny: "2px",
  xxs: "4px",
  xs: "8px",
  xtSm: "10px",
  input: "10.5px",
  sm: "12px",
  md: "16px",
  xtMd: "24px",
  lg: "32px",
  xl: "40px",
  xxl: "48px"
}, qe = {
  defaultGray: `2px solid ${rt.gray}`,
  defaultGrayLight: `1px solid ${rt.grayLight}`,
  defaultGrayMedium: `1px solid ${rt.grayMedium}`,
  defaultGrayExtraLight: `1px solid ${rt.grayExtraLight}`,
  defaultBlue: `1px solid ${rt.blue}`,
  defaultBlueDark: `2px solid ${rt.blueDark}`,
  defaultRed: `2px solid ${rt.red}`,
  focusBlue: `2px solid ${rt.blue}`,
  white: `1px solid ${rt.white}`
}, Ze = {
  widthXs: "520px",
  widthSm: "640px",
  widthMd: "760px",
  widthLg: "880px",
  widthXl: "960px"
}, xt = {
  mobileMin: "320px",
  mobileMax: "560px",
  tabletMin: "561px",
  tabletMax: "1020px",
  desktopMin: "1021px"
}, Je = {
  blue: "3px solid rgba(20, 119, 216, 0.75)",
  gray: "3px solid rgba(89, 89, 89, 0.75)",
  red: "3px solid rgba(210, 70, 54, 0.75)",
  green: "3px solid rgba(38, 137, 0, 0.76)"
}, a = {
  color: rt,
  fontFamily: Xe,
  fontWeight: Ye,
  schoolinks: Ue,
  spacing: Ge,
  border: qe,
  modal: Ze,
  breakpoint: xt,
  focusOutline: Je
}, Qe = `@import './gtflexa.css';
@import './halisrounded.css';
/* 
* This file is auto-generated by running "yarn run build" (not "yarn run dev"). 
* Do not edit this file directly as changes will be overwritten.
* Add or update variables in src/utils/variables.js.
*/`, Ke = (t) => {
  const o = [];
  for (const r in t) {
    const n = Ie(r), f = t[r];
    for (const i in f) {
      const d = i.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase(), u = `--${n}-${d}`, y = f[i];
      o.push(`${u}: ${y};`);
    }
  }
  return `${Qe}
:root {
${o.map((r) => `  ${r}`).join(`
`)}
}
`;
}, ri = () => {
  let t = !1;
  return {
    name: "generate-css-vars",
    apply: "build",
    config(o) {
      var r;
      (r = o.build) != null && r.watch && (t = !0);
    },
    buildStart() {
      if (t)
        return;
      console.log("Generating CSS variables...");
      const o = Ke(a), r = Ht.resolve("./src/utils/variables.css");
      Ht.writeFileSync(r, o, "utf-8"), console.log(`CSS variables written to ${r}`);
    }
  };
}, Ve = {
  lead400: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  lead500: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  lead700: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  titleMd500: {
    fontSize: 16,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  titleMd700: {
    fontSize: 16,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  titleSm500: {
    fontSize: 14,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  titleSm700: {
    fontSize: 14,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodyMd400: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd500: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd600: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd700: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm400: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm500: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm600: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm700: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  meta400: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  meta700: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  label: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  tiny: {
    fontSize: 10,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "12px"
  },
  mono: {
    fontSize: 14,
    fontFamily: a.fontFamily.code,
    fontWeight: "bolder",
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "16px"
  },
  cursive: {
    fontSize: 16,
    fontFamily: a.fontFamily.signature,
    fontWeight: "bolder",
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "18px"
  },
  stat1: {
    fontSize: 40,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "46px"
  },
  stat2: {
    fontSize: 34,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "38px"
  },
  stat3: {
    fontSize: 30,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "34px"
  },
  stat4: {
    fontSize: 26,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "30px"
  },
  stat5: {
    fontSize: 22,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "26px"
  },
  stat6: {
    fontSize: 20,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "24px"
  },
  h1: {
    fontSize: 40,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "46px"
  },
  h2: {
    fontSize: 34,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "38px"
  },
  h3: {
    fontSize: 30,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "34px"
  },
  h4: {
    fontSize: 26,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "30px"
  },
  h5: {
    fontSize: 22,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "26px"
  },
  h6: {
    fontSize: 20,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  body1: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "19px"
  },
  body2: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  caption: {
    fontSize: 12,
    letterSpacing: "0",
    fontFamily: a.fontFamily.body,
    fontStyle: "normal",
    fontWeight: a.fontWeight.robotoMedium,
    lineHeight: "16px"
  },
  overline: {
    fontSize: 10,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    fontFamily: a.fontFamily.body,
    fontWeight: "bold",
    fontStyle: "normal",
    lineHeight: "16px"
  },
  subtitle1: {
    fontSize: 16,
    letterSpacing: "0.15px",
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  subtitle2: {
    fontSize: 14,
    letterSpacing: "0.1px",
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  button: {
    fontSize: 16,
    letterSpacing: "1.2px",
    fontFamily: a.fontFamily.base,
    textTransform: "none",
    fontStyle: "normal",
    fontWeight: a.fontWeight.halisBook,
    lineHeight: "16px"
  }
}, { color: $ } = a, Pe = ee({
  typography: Ve,
  palette: {
    primary: {
      main: $.blue,
      light: $.blue,
      dark: $.blueDark,
      contrastText: $.white
    },
    secondary: {
      main: $.blue,
      light: $.blue,
      dark: $.blueDark,
      contrastText: $.white
    },
    action: {
      hover: $.blueExtraLight,
      selected: $.blueExtraLight
    },
    error: {
      main: "#d85446"
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      // mobile
      md: 561,
      // tablet
      lg: 1021,
      // desktop
      xl: 1600
    }
  },
  components: {
    // Customization
    /*
      Body font properties updated to v4 to prevent UI bugs.
      Related documentation.
      https://mui.com/guides/migration-v4/#cssbaseline
    */
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          lineHeight: "1.43",
          letterSpacing: "0.01071em"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "linear-gradient(0deg, rgba(2, 136, 209, 0.15), rgba(2, 136, 209, 0.15)), var(--color-white)"
        },
        icon: {
          marginRight: 4
        },
        deleteIcon: {
          marginLeft: 4
        },
        colorPrimary: {
          backgroundColor: $.blueExtraLight,
          color: $.font,
          "& > svg": {
            color: $.font
          }
        },
        deleteIconColorPrimary: {
          "&:hover": {
            color: $.font
          }
        },
        deletableColorPrimary: {
          "&:focus": {
            backgroundColor: $.blueDark
          }
        }
      }
    },
    // new overrides to counter breaking changes in mui v4
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          margin: "4px 0",
          color: $.grayDark,
          "&.Mui-disabled": { color: $.grayDark },
          "&.Mui-error": { color: "#d85446" }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard"
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: a.schoolinks.containerBorderRadius,
            "&.Mui-disabled": {
              backgroundColor: $.grayBg,
              "& fieldset": { borderColor: "#eee" }
            },
            "& fieldset": {
              borderColor: $.grayLight
            },
            "&:not(.Mui-disabled, .Mui-error):hover fieldset": {
              borderColor: $.blue
            },
            "&.Mui-error fieldset": {
              borderColor: $.red,
              borderWidth: "2px"
            },
            "& input::placeholder": {
              opacity: 1,
              color: $.gray
            }
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&.Mui-disabled": {
            "-webkit-text-fill-color": $.grayDark
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: "6px 12px"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: 11,
          paddingBottom: 11
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: 1400
          // has to be bigger than the MuiModal zIndex
        },
        option: {
          "&.Mui-focused": {
            backgroundColor: `${$.blueDark} !important`
          }
        }
      }
    },
    // existing overrides
    MuiModal: {
      styleOverrides: {
        root: {
          // lowered from 1350 to 1300 so we can see date pickers in modals
          zIndex: 1300
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        maxWidth: !1
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          zIndex: 1300
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            // underline color when textfield is inactive
            borderBottom: "2px solid #d8d8d8"
          },
          "&:after": {
            // underline color when textfield is active
            borderBottom: `2px solid ${$.blue}`
          },
          "&:hover:not($disabled):not($focused):not($error):before": {
            // underline color when hovered
            borderBottom: `2px solid ${$.blue}`
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
            // outline color when hovered
            borderColor: $.blue
          },
          "&$error $notchedOutline": {
            borderColor: $.red
          }
        },
        inputAdornedStart: {
          paddingLeft: 0
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&$focused": {
            color: `${$.grayDark} !important`
          },
          "&$error": {
            color: $.red
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          paddingRight: 16,
          "&.Mui-focused": {
            color: `${$.grayDark} !important`
          },
          "&.Mui-error": {
            color: `${$.grayDark} !important`
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&$selected": {
            backgroundColor: "rgba(2,136,209,0.05)"
          },
          "&$hover:hover": {
            backgroundColor: "rgba(2,136,209,0.05)"
          }
        }
      }
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (t) => t === "next" ? "Next Page" : t === "previous" ? "Previous Page" : ""
      },
      styleOverrides: {
        selectLabel: {
          margin: 0
        },
        displayedRows: {
          margin: 0
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#bbb !important",
          "&$active": {
            color: `${$.blue} !important`
          },
          "&$completed": {
            color: `${$.blue} !important`
          }
        },
        active: {},
        completed: {}
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: void 0
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "& > .textLink, & > .textLinkButton": {
            textDecoration: "underline"
          }
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiYearPicker: {
      styleOverrides: {
        root: {
          "& .PrivatePickersYear-yearButton": {
            fontFamily: "Roboto, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }
        }
      }
    },
    PrivatePickersYear: {
      styleOverrides: {
        yearButton: {
          fontFamily: "Roboto, sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    }
  }
}), to = "_badgeContainer_6t1ke_3", eo = "_label_6t1ke_9", oo = "_large_6t1ke_18", no = "_badge_6t1ke_3", ro = "_number_6t1ke_29", ao = "_font_6t1ke_42", io = "_outlined_6t1ke_46", lo = "_text_6t1ke_51", so = "_orange_6t1ke_56", co = "_red_6t1ke_70", fo = "_blue_6t1ke_84", uo = "_green_6t1ke_98", mo = "_yellow_6t1ke_112", ho = "_purple_6t1ke_126", go = "_gray_6t1ke_140", bo = "_blueSteel_6t1ke_154", po = "_disabled_6t1ke_168", yo = "_transparent_6t1ke_182", _o = "_hasWhiteBorder_6t1ke_186", J = {
  badgeContainer: to,
  label: eo,
  large: oo,
  badge: no,
  number: ro,
  font: ao,
  outlined: io,
  text: lo,
  orange: so,
  red: co,
  blue: fo,
  green: uo,
  yellow: mo,
  purple: ho,
  gray: go,
  blueSteel: bo,
  disabled: po,
  transparent: yo,
  hasWhiteBorder: _o
}, qt = ({
  label: t,
  style: o,
  classes: r,
  number: n = 0,
  color: f = "gray",
  size: i = "medium",
  variant: d = "filled",
  disableEmpty: u = !0,
  hasWhiteBorder: y = !1,
  badgeClassName: v
}) => {
  const g = i === "large", x = d === "filled", C = d === "outlined", k = d === "text";
  return /* @__PURE__ */ W("div", { style: o, className: L(J.badgeContainer, r == null ? void 0 : r.root), children: [
    /* @__PURE__ */ e(
      "div",
      {
        "data-testid": "badgeNumberContainer",
        className: L(
          J.badge,
          J[je(f)],
          {
            [J.transparent]: !x,
            [J.disabled]: f === "disabled" || u && !n,
            [J.filled]: x,
            [J.outlined]: C,
            [J.text]: k,
            [J.whiteBorder]: y && x
          },
          v
        ),
        children: /* @__PURE__ */ e(
          "div",
          {
            "data-testid": "badgeNumber",
            className: L(J.number, { [J.large]: g }),
            children: n
          }
        )
      }
    ),
    t ? /* @__PURE__ */ e(
      "div",
      {
        "data-testid": "badgeLabel",
        className: L(J.label, { [J.large]: g }),
        children: t
      }
    ) : null
  ] });
}, xo = "_button_55z78_1", wo = "_withIconLeft_55z78_19", vo = "_withLabel_55z78_19", So = "_withIconRight_55z78_20", ko = "_disabled_55z78_24", Mo = "_loading_55z78_29", $o = "_small_55z78_33", Co = "_withWhiteBackground_55z78_44", Do = "_compactButton_55z78_50", Lo = "_compactSmall_55z78_63", Wo = "_compactSelect_55z78_67", zo = "_compactCircular_55z78_73", To = "_compactLabel_55z78_82", Bo = "_text_55z78_91", Fo = "_blue_55z78_96", Oo = "_filled_55z78_97", No = "_outlined_55z78_112", Ro = "_badge_55z78_160", Ho = "_gray_55z78_165", Ao = "_red_55z78_234", Eo = "_badgeContainer_55z78_307", Io = "_shadowButton_55z78_315", jo = "_rightIcon_55z78_466", Xo = "_large_55z78_470", Yo = "_icon_55z78_470", Uo = "_noLabel_55z78_471", Go = "_medium_55z78_476", qo = "_noLabelContainer_55z78_493", Zo = "_label_55z78_497", Jo = "_popoverRoot_55z78_517", Qo = "_popoverPaper_55z78_521", Ko = "_arrow_55z78_527", Vo = "_arrowTop_55z78_528", Po = "_arrowBottom_55z78_529", m = {
  button: xo,
  withIconLeft: wo,
  withLabel: vo,
  withIconRight: So,
  disabled: ko,
  loading: Mo,
  small: $o,
  withWhiteBackground: Co,
  compactButton: Do,
  compactSmall: Lo,
  compactSelect: Wo,
  compactCircular: zo,
  compactLabel: To,
  text: Bo,
  blue: Fo,
  filled: Oo,
  outlined: No,
  badge: Ro,
  gray: Ho,
  red: Ao,
  badgeContainer: Eo,
  shadowButton: Io,
  rightIcon: jo,
  large: Xo,
  icon: Yo,
  noLabel: Uo,
  medium: Go,
  noLabelContainer: qo,
  label: Zo,
  popoverRoot: Jo,
  popoverPaper: Qo,
  arrow: Ko,
  arrowTop: Vo,
  arrowBottom: Po
}, tn = ({
  badgeCount: t,
  color: o,
  component: r,
  handleClick: n,
  hasIconLeft: f,
  hasIconRight: i,
  hasNoWrap: d,
  hasWhiteBackground: u,
  iconToRender: y,
  isFilled: v,
  isLoading: g,
  isOutlined: x,
  isSmall: C,
  isText: k,
  label: M,
  showBadge: b,
  tooltipProps: F,
  ...D
}) => /* @__PURE__ */ e(gt, { title: (F == null ? void 0 : F.title) ?? "", ...F, children: /* @__PURE__ */ W(
  r,
  {
    "data-testid": "base-button",
    ...D,
    className: L(D.className, m.button, {
      [m.small]: C,
      [m.disabled]: D.disabled,
      [m.text]: k,
      [m.loading]: g,
      [m.blue]: o === "blue",
      [m.red]: o === "red",
      [m.gray]: o === "gray",
      [m.withIconLeft]: f,
      [m.withIconRight]: i,
      [m.withLabel]: M,
      [m.filled]: v,
      [m.outlined]: x,
      [m.withWhiteBackground]: u
    }),
    style: {
      whiteSpace: d ? "nowrap" : void 0,
      ...D.style
    },
    onClick: n,
    children: [
      (f || g) && y,
      /* @__PURE__ */ e("span", { children: M }),
      i && y,
      b && /* @__PURE__ */ e(
        qt,
        {
          number: t ?? 0,
          color: o,
          hasWhiteBorder: !0,
          classes: { root: m.badgeContainer },
          badgeClassName: m.badge
        }
      )
    ]
  }
) }), en = ({
  badgeCount: t,
  color: o,
  component: r,
  handleClick: n,
  hasNoWrap: f,
  hasWhiteBackground: i,
  iconToRender: d,
  innerLabel: u,
  isCompactSelect: y,
  isFilled: v,
  isLoading: g,
  isOutlined: x,
  isSmall: C,
  isText: k,
  label: M,
  showBadge: b,
  textVariant: F,
  tooltipProps: D,
  ...A
}) => /* @__PURE__ */ e(gt, { title: (D == null ? void 0 : D.title) ?? "", ...D, children: /* @__PURE__ */ W(I, { flexDirection: "column", alignItems: "center", width: "fit-content", children: [
  /* @__PURE__ */ W(
    r,
    {
      "data-testid": "compact-button",
      ...A,
      className: L(m.compactButton, A.className, {
        [m.compactCircular]: !C,
        [m.compactSmall]: C,
        [m.compactSelect]: y,
        [m.compactSmallSelect]: C && y,
        [m.disabled]: A.disabled,
        [m.loading]: g,
        [m.blue]: o === "blue",
        [m.red]: o === "red",
        [m.gray]: o === "gray",
        [m.text]: k,
        [m.filled]: v,
        [m.outlined]: x,
        [m.withWhiteBackground]: i
      }),
      style: {
        whiteSpace: f ? "nowrap" : void 0,
        ...A.style
      },
      onClick: n,
      children: [
        u && /* @__PURE__ */ e(st, { variant: F, children: u }),
        d,
        y && /* @__PURE__ */ e(B, { icon: ae }),
        b && /* @__PURE__ */ e(
          qt,
          {
            number: t ?? 0,
            color: o,
            hasWhiteBorder: !0,
            classes: { root: m.badge }
          }
        )
      ]
    }
  ),
  M && /* @__PURE__ */ e(
    st,
    {
      className: m.compactLabel,
      color: `${o}XtraDark`,
      variant: "label",
      mt: 0.5,
      children: M
    }
  )
] }) }), on = ({ title: t }) => typeof t == "string" ? /* @__PURE__ */ e(vt, { children: t }) : t, nn = "_tooltip_1hh81_3", rn = {
  tooltip: nn
}, gt = ({
  title: t = "",
  arrow: o = !0,
  tooltipClass: r = "",
  children: n,
  ...f
}) => {
  const { classes: i = {} } = f;
  return /* @__PURE__ */ e(
    ie,
    {
      ...f,
      classes: {
        ...i,
        tooltip: L(rn.tooltip, r)
      },
      title: t && /* @__PURE__ */ e(on, { title: t }),
      enterTouchDelay: 0,
      arrow: o,
      children: n
    }
  );
}, an = {
  blue: m.blue,
  gray: m.gray,
  red: m.red,
  green: m.green
}, ln = {
  outlined: m.outlined,
  filled: m.filled,
  text: m.text
}, sn = {
  large: m.large,
  medium: m.medium,
  small: m.small
}, cn = ({
  classes: t,
  color: o = "blue",
  component: r,
  handleClick: n,
  hasIconRight: f,
  iconToRender: i,
  isLoading: d,
  label: u,
  size: y = "large",
  tooltipProps: v,
  variant: g = "outlined",
  ...x
}) => /* @__PURE__ */ e(gt, { title: (v == null ? void 0 : v.title) ?? "", ...v, children: /* @__PURE__ */ W(
  r,
  {
    "data-testid": "shadow-button",
    ...x,
    className: L(
      m.shadowButton,
      an[o],
      ln[g] || m.outlined,
      sn[y],
      {
        [m.rightIcon]: f,
        [m.disabled]: x.disabled,
        [m.noLabelContainer]: !u,
        [m.loading]: d
      },
      x.className
    ),
    onClick: n,
    children: [
      i ? /* @__PURE__ */ e("span", { className: L(m.icon, { [m.noLabel]: !u }, t == null ? void 0 : t.icon), children: i }) : null,
      u ? /* @__PURE__ */ e("span", { className: L(m.label, t == null ? void 0 : t.label), children: u }) : null
    ]
  }
) }), wt = (t) => /^http(s)?:\/\//.test(t) || /mailto:([^?]*)/.test(t), Tt = ({
  badgeCount: t,
  children: o,
  classes: r,
  color: n = "blue",
  compactVariant: f,
  confirmationPopoverProps: i,
  hasIconLeft: d,
  hasIconRight: u,
  hasNoWrap: y,
  hasWhiteBackground: v,
  href: g,
  icon: x,
  innerLabel: C,
  isLoading: k,
  label: M,
  newTab: b,
  size: F = "medium",
  textVariant: D,
  tooltipProps: A,
  variant: E,
  withShadow: Z,
  ...O
}) => {
  const [U, Y] = ht(null), at = ({
    currentTarget: j
  }) => Y(j), et = (j) => {
    j && j.stopPropagation(), Y(null);
  }, T = !!U, S = T ? "popover" : void 0, it = f === "select", dt = f === "default", p = F === "small", s = E === "outlined", l = E === "filled", h = E === "text" || !s && !l, w = !!t && (s || dt), {
    confirmationOpenColor: _,
    confirmationButtonColor: z,
    confirmationText: N,
    confirmationPopover: R,
    confirmationButtonText: X,
    confirmationPopoverCancelButtonText: q,
    arrowDirection: P,
    arrow: lt,
    popoverPaperClassName: ft
  } = i ?? {}, ot = {
    arrow: /* @__PURE__ */ e(
      B,
      {
        rotation: d ? 180 : void 0,
        icon: ge
      }
    ),
    chevron: /* @__PURE__ */ e(
      B,
      {
        icon: u || d ? pe : be,
        rotation: d ? 180 : void 0
      }
    ),
    edit: /* @__PURE__ */ e(B, { "data-testid": "edit-icon", icon: ue }),
    plus: /* @__PURE__ */ e(B, { icon: me }),
    trash: /* @__PURE__ */ e(B, { icon: he }),
    lock: /* @__PURE__ */ e(B, { icon: fe }),
    download: /* @__PURE__ */ e(B, { icon: ce })
  }, tt = k ? /* @__PURE__ */ e(B, { "data-testid": "loader-icon", icon: de, spin: !0 }) : Object.keys(ot).includes(x) ? ot[x] : x, ct = (j) => {
    var pt;
    if (!(k || O.disabled)) {
      if (N || R) {
        j.stopPropagation(), at(j);
        return;
      }
      (pt = O.onClick) == null || pt.call(O, j);
    }
  }, Nt = (() => {
    if (!g || O.disabled)
      return {
        component: "button",
        to: ""
      };
    const j = b || wt(g) ? { target: "_blank", rel: "noopener noreferrer" } : {};
    return wt(g) ? { component: "a", to: "", href: g, ...j } : { component: Ct, to: g, ...j };
  })();
  return /* @__PURE__ */ W(vt, { children: [
    (() => {
      if (Z)
        return /* @__PURE__ */ e(
          cn,
          {
            classes: r,
            color: _ ?? n,
            handleClick: ct,
            hasIconLeft: d,
            hasIconRight: u,
            iconToRender: tt,
            isLoading: k,
            label: M,
            size: F,
            tooltipProps: A,
            variant: E,
            ...O,
            ...Nt
          }
        );
      const j = {
        badgeCount: t,
        color: _ ?? n,
        handleClick: ct,
        hasNoWrap: y,
        hasWhiteBackground: v,
        iconToRender: tt,
        isLoading: k,
        isSmall: p,
        label: M,
        showBadge: w,
        tooltipProps: A,
        isText: h,
        isFilled: l,
        isOutlined: s,
        ...O,
        ...Nt
      };
      return it || dt ? /* @__PURE__ */ e(
        en,
        {
          isCompactSelect: it,
          innerLabel: C,
          textVariant: D,
          ...j
        }
      ) : /* @__PURE__ */ e(
        tn,
        {
          hasIconLeft: d,
          hasIconRight: u,
          ...j
        }
      );
    })(),
    /* @__PURE__ */ e(
      Ut,
      {
        id: S,
        open: T,
        anchorEl: U,
        onClose: et,
        anchorOrigin: {
          vertical: P === "top" ? "bottom" : "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: P === "top" ? "top" : "bottom",
          horizontal: "center"
        },
        classes: {
          root: m.popoverRoot,
          paper: L(m.popoverPaper, ft, {
            [m.arrow]: lt,
            [m.arrowTop]: P === "top",
            [m.arrowBottom]: P === "bottom"
          })
        },
        ...i,
        children: R ? R({
          closePopover: () => Y(null)
        }) : /* @__PURE__ */ W("div", { children: [
          N && /* @__PURE__ */ e(st, { variant: "bodySm400", mb: 1.5, children: N }),
          /* @__PURE__ */ W(
            I,
            {
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              children: [
                /* @__PURE__ */ e(
                  Tt,
                  {
                    label: q ?? "Cancel",
                    size: "small",
                    color: "gray",
                    variant: "text",
                    onClick: (j) => {
                      j.stopPropagation(), Y(null);
                    }
                  }
                ),
                /* @__PURE__ */ e(
                  Tt,
                  {
                    label: X ?? "Delete",
                    size: "small",
                    variant: "outlined",
                    color: z ?? "red",
                    onClick: (j) => {
                      var pt;
                      j.stopPropagation(), (pt = O.onClick) == null || pt.call(O, j), Y(null);
                    }
                  }
                )
              ]
            }
          )
        ] })
      }
    )
  ] });
};
function dn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $t = { exports: {} }, fn = $t.exports, At;
function un() {
  return At || (At = 1, function(t, o) {
    (function(r, n) {
      t.exports = n();
    })(fn, function() {
      var r = 1e3, n = 6e4, f = 36e5, i = "millisecond", d = "second", u = "minute", y = "hour", v = "day", g = "week", x = "month", C = "quarter", k = "year", M = "date", b = "Invalid Date", F = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, D = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, A = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(p) {
        var s = ["th", "st", "nd", "rd"], l = p % 100;
        return "[" + p + (s[(l - 20) % 10] || s[l] || s[0]) + "]";
      } }, E = function(p, s, l) {
        var h = String(p);
        return !h || h.length >= s ? p : "" + Array(s + 1 - h.length).join(l) + p;
      }, Z = { s: E, z: function(p) {
        var s = -p.utcOffset(), l = Math.abs(s), h = Math.floor(l / 60), c = l % 60;
        return (s <= 0 ? "+" : "-") + E(h, 2, "0") + ":" + E(c, 2, "0");
      }, m: function p(s, l) {
        if (s.date() < l.date()) return -p(l, s);
        var h = 12 * (l.year() - s.year()) + (l.month() - s.month()), c = s.clone().add(h, x), w = l - c < 0, _ = s.clone().add(h + (w ? -1 : 1), x);
        return +(-(h + (l - c) / (w ? c - _ : _ - c)) || 0);
      }, a: function(p) {
        return p < 0 ? Math.ceil(p) || 0 : Math.floor(p);
      }, p: function(p) {
        return { M: x, y: k, w: g, d: v, D: M, h: y, m: u, s: d, ms: i, Q: C }[p] || String(p || "").toLowerCase().replace(/s$/, "");
      }, u: function(p) {
        return p === void 0;
      } }, O = "en", U = {};
      U[O] = A;
      var Y = "$isDayjsObject", at = function(p) {
        return p instanceof it || !(!p || !p[Y]);
      }, et = function p(s, l, h) {
        var c;
        if (!s) return O;
        if (typeof s == "string") {
          var w = s.toLowerCase();
          U[w] && (c = w), l && (U[w] = l, c = w);
          var _ = s.split("-");
          if (!c && _.length > 1) return p(_[0]);
        } else {
          var z = s.name;
          U[z] = s, c = z;
        }
        return !h && c && (O = c), c || !h && O;
      }, T = function(p, s) {
        if (at(p)) return p.clone();
        var l = typeof s == "object" ? s : {};
        return l.date = p, l.args = arguments, new it(l);
      }, S = Z;
      S.l = et, S.i = at, S.w = function(p, s) {
        return T(p, { locale: s.$L, utc: s.$u, x: s.$x, $offset: s.$offset });
      };
      var it = function() {
        function p(l) {
          this.$L = et(l.locale, null, !0), this.parse(l), this.$x = this.$x || l.x || {}, this[Y] = !0;
        }
        var s = p.prototype;
        return s.parse = function(l) {
          this.$d = function(h) {
            var c = h.date, w = h.utc;
            if (c === null) return /* @__PURE__ */ new Date(NaN);
            if (S.u(c)) return /* @__PURE__ */ new Date();
            if (c instanceof Date) return new Date(c);
            if (typeof c == "string" && !/Z$/i.test(c)) {
              var _ = c.match(F);
              if (_) {
                var z = _[2] - 1 || 0, N = (_[7] || "0").substring(0, 3);
                return w ? new Date(Date.UTC(_[1], z, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, N)) : new Date(_[1], z, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, N);
              }
            }
            return new Date(c);
          }(l), this.init();
        }, s.init = function() {
          var l = this.$d;
          this.$y = l.getFullYear(), this.$M = l.getMonth(), this.$D = l.getDate(), this.$W = l.getDay(), this.$H = l.getHours(), this.$m = l.getMinutes(), this.$s = l.getSeconds(), this.$ms = l.getMilliseconds();
        }, s.$utils = function() {
          return S;
        }, s.isValid = function() {
          return this.$d.toString() !== b;
        }, s.isSame = function(l, h) {
          var c = T(l);
          return this.startOf(h) <= c && c <= this.endOf(h);
        }, s.isAfter = function(l, h) {
          return T(l) < this.startOf(h);
        }, s.isBefore = function(l, h) {
          return this.endOf(h) < T(l);
        }, s.$g = function(l, h, c) {
          return S.u(l) ? this[h] : this.set(c, l);
        }, s.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, s.valueOf = function() {
          return this.$d.getTime();
        }, s.startOf = function(l, h) {
          var c = this, w = !!S.u(h) || h, _ = S.p(l), z = function(ot, G) {
            var tt = S.w(c.$u ? Date.UTC(c.$y, G, ot) : new Date(c.$y, G, ot), c);
            return w ? tt : tt.endOf(v);
          }, N = function(ot, G) {
            return S.w(c.toDate()[ot].apply(c.toDate("s"), (w ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(G)), c);
          }, R = this.$W, X = this.$M, q = this.$D, P = "set" + (this.$u ? "UTC" : "");
          switch (_) {
            case k:
              return w ? z(1, 0) : z(31, 11);
            case x:
              return w ? z(1, X) : z(0, X + 1);
            case g:
              var lt = this.$locale().weekStart || 0, ft = (R < lt ? R + 7 : R) - lt;
              return z(w ? q - ft : q + (6 - ft), X);
            case v:
            case M:
              return N(P + "Hours", 0);
            case y:
              return N(P + "Minutes", 1);
            case u:
              return N(P + "Seconds", 2);
            case d:
              return N(P + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, s.endOf = function(l) {
          return this.startOf(l, !1);
        }, s.$set = function(l, h) {
          var c, w = S.p(l), _ = "set" + (this.$u ? "UTC" : ""), z = (c = {}, c[v] = _ + "Date", c[M] = _ + "Date", c[x] = _ + "Month", c[k] = _ + "FullYear", c[y] = _ + "Hours", c[u] = _ + "Minutes", c[d] = _ + "Seconds", c[i] = _ + "Milliseconds", c)[w], N = w === v ? this.$D + (h - this.$W) : h;
          if (w === x || w === k) {
            var R = this.clone().set(M, 1);
            R.$d[z](N), R.init(), this.$d = R.set(M, Math.min(this.$D, R.daysInMonth())).$d;
          } else z && this.$d[z](N);
          return this.init(), this;
        }, s.set = function(l, h) {
          return this.clone().$set(l, h);
        }, s.get = function(l) {
          return this[S.p(l)]();
        }, s.add = function(l, h) {
          var c, w = this;
          l = Number(l);
          var _ = S.p(h), z = function(X) {
            var q = T(w);
            return S.w(q.date(q.date() + Math.round(X * l)), w);
          };
          if (_ === x) return this.set(x, this.$M + l);
          if (_ === k) return this.set(k, this.$y + l);
          if (_ === v) return z(1);
          if (_ === g) return z(7);
          var N = (c = {}, c[u] = n, c[y] = f, c[d] = r, c)[_] || 1, R = this.$d.getTime() + l * N;
          return S.w(R, this);
        }, s.subtract = function(l, h) {
          return this.add(-1 * l, h);
        }, s.format = function(l) {
          var h = this, c = this.$locale();
          if (!this.isValid()) return c.invalidDate || b;
          var w = l || "YYYY-MM-DDTHH:mm:ssZ", _ = S.z(this), z = this.$H, N = this.$m, R = this.$M, X = c.weekdays, q = c.months, P = c.meridiem, lt = function(G, tt, ct, bt) {
            return G && (G[tt] || G(h, w)) || ct[tt].slice(0, bt);
          }, ft = function(G) {
            return S.s(z % 12 || 12, G, "0");
          }, ot = P || function(G, tt, ct) {
            var bt = G < 12 ? "AM" : "PM";
            return ct ? bt.toLowerCase() : bt;
          };
          return w.replace(D, function(G, tt) {
            return tt || function(ct) {
              switch (ct) {
                case "YY":
                  return String(h.$y).slice(-2);
                case "YYYY":
                  return S.s(h.$y, 4, "0");
                case "M":
                  return R + 1;
                case "MM":
                  return S.s(R + 1, 2, "0");
                case "MMM":
                  return lt(c.monthsShort, R, q, 3);
                case "MMMM":
                  return lt(q, R);
                case "D":
                  return h.$D;
                case "DD":
                  return S.s(h.$D, 2, "0");
                case "d":
                  return String(h.$W);
                case "dd":
                  return lt(c.weekdaysMin, h.$W, X, 2);
                case "ddd":
                  return lt(c.weekdaysShort, h.$W, X, 3);
                case "dddd":
                  return X[h.$W];
                case "H":
                  return String(z);
                case "HH":
                  return S.s(z, 2, "0");
                case "h":
                  return ft(1);
                case "hh":
                  return ft(2);
                case "a":
                  return ot(z, N, !0);
                case "A":
                  return ot(z, N, !1);
                case "m":
                  return String(N);
                case "mm":
                  return S.s(N, 2, "0");
                case "s":
                  return String(h.$s);
                case "ss":
                  return S.s(h.$s, 2, "0");
                case "SSS":
                  return S.s(h.$ms, 3, "0");
                case "Z":
                  return _;
              }
              return null;
            }(G) || _.replace(":", "");
          });
        }, s.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, s.diff = function(l, h, c) {
          var w, _ = this, z = S.p(h), N = T(l), R = (N.utcOffset() - this.utcOffset()) * n, X = this - N, q = function() {
            return S.m(_, N);
          };
          switch (z) {
            case k:
              w = q() / 12;
              break;
            case x:
              w = q();
              break;
            case C:
              w = q() / 3;
              break;
            case g:
              w = (X - R) / 6048e5;
              break;
            case v:
              w = (X - R) / 864e5;
              break;
            case y:
              w = X / f;
              break;
            case u:
              w = X / n;
              break;
            case d:
              w = X / r;
              break;
            default:
              w = X;
          }
          return c ? w : S.a(w);
        }, s.daysInMonth = function() {
          return this.endOf(x).$D;
        }, s.$locale = function() {
          return U[this.$L];
        }, s.locale = function(l, h) {
          if (!l) return this.$L;
          var c = this.clone(), w = et(l, h, !0);
          return w && (c.$L = w), c;
        }, s.clone = function() {
          return S.w(this.$d, this);
        }, s.toDate = function() {
          return new Date(this.valueOf());
        }, s.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, s.toISOString = function() {
          return this.$d.toISOString();
        }, s.toString = function() {
          return this.$d.toUTCString();
        }, p;
      }(), dt = it.prototype;
      return T.prototype = dt, [["$ms", i], ["$s", d], ["$m", u], ["$H", y], ["$W", v], ["$M", x], ["$y", k], ["$D", M]].forEach(function(p) {
        dt[p[1]] = function(s) {
          return this.$g(s, p[0], p[1]);
        };
      }), T.extend = function(p, s) {
        return p.$i || (p(s, it, T), p.$i = !0), T;
      }, T.locale = et, T.isDayjs = at, T.unix = function(p) {
        return T(1e3 * p);
      }, T.en = U[O], T.Ls = U, T.p = {}, T;
    });
  }($t)), $t.exports;
}
var mn = un();
const ut = /* @__PURE__ */ dn(mn), hn = ({ event: t, children: o }) => /* @__PURE__ */ e(
  "div",
  {
    className: L("rbc-event-wrapper", t.color ?? "", {
      "rbc-event-filled": t.variant === "filled",
      "rbc-event-white-label": t.whiteLabel
    }),
    children: o
  }
);
[...Intl.supportedValuesOf("timeZone")];
var Bt = /* @__PURE__ */ ((t) => (t.Back = "back", t.Forward = "forward", t))(Bt || {});
const gn = ({
  disabled: t,
  viewMode: o,
  viewLabel: r,
  onMove: n,
  onMoveToday: f,
  onChangeView: i
}) => /* @__PURE__ */ W(
  I,
  {
    className: "rbc-toolbar",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 0.5,
    children: [
      /* @__PURE__ */ e(I, { className: "rbc-left-toolbar", children: /* @__PURE__ */ e(
        "button",
        {
          className: "rbc-btn-standalone rbc-btn-today",
          type: "button",
          onClick: f,
          disabled: t,
          children: "Today"
        }
      ) }),
      /* @__PURE__ */ W(I, { gap: 0.5, alignItems: "center", children: [
        /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move back",
            disabled: t,
            onClick: () => {
              n(Bt.Back);
            },
            children: /* @__PURE__ */ e(B, { icon: Rt })
          }
        ),
        /* @__PURE__ */ e("h2", { className: "rbc-toolbar-label", children: r }),
        /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move forward",
            disabled: t,
            onClick: () => {
              n(Bt.Forward);
            },
            children: /* @__PURE__ */ e(B, { icon: Rt, rotation: 180 })
          }
        )
      ] }),
      /* @__PURE__ */ e("div", { className: "rbc-btn-group rbc-right-toolbar", children: ["Month", "Week", "Day"].map((u) => /* @__PURE__ */ e(
        "button",
        {
          type: "button",
          disabled: t,
          onClick: () => {
            i(u.toLowerCase());
          },
          className: L({
            "rbc-active": o === u.toLowerCase()
          }),
          children: u
        },
        u
      )) })
    ]
  }
), bn = {
  mobile: `(max-width: ${xt.mobileMax})`,
  tablet: `(min-width: ${xt.tabletMin}) and (max-width: ${xt.tabletMax})`,
  desktop: `(min-width: ${xt.desktopMin})`
}, pn = (t = bn) => {
  const o = Lt(t.mobile), r = Lt(t.tablet), n = Lt(t.desktop);
  return { isMobile: o, isTablet: r, isDesktop: n };
}, yn = ({ tag: t }) => ["a", "button"].includes(t), _n = "_buttonAdjustments_1vavw_5", xn = "_anchorAdjustments_1vavw_38", wn = "_pointer_1vavw_49", vn = "_fullWidth_1vavw_53", St = {
  buttonAdjustments: _n,
  anchorAdjustments: xn,
  pointer: wn,
  fullWidth: vn
}, Zt = ne(
  ({
    tagName: t = "button",
    children: o,
    className: r,
    disabled: n,
    fullWidth: f,
    href: i,
    onClick: d = () => null,
    testId: u,
    ...y
  }, v) => {
    const g = (b) => {
      n || d(b);
    }, x = {
      ...y,
      ...t === "button" ? { type: "button" } : {}
    }, C = !n && i ? i : void 0, k = i ? "a" : "button", M = yn({ tag: t }) ? t : k;
    return /* @__PURE__ */ e(
      M,
      {
        ref: v,
        className: L(r, {
          [St.buttonAdjustments]: M === "button",
          [St.anchorAdjustments]: M === "a",
          [St.pointer]: !n,
          [St.fullWidth]: f
        }),
        disabled: n,
        onClick: g,
        href: C,
        "data-testid": u,
        ...x,
        children: o
      }
    );
  }
), I = mt.forwardRef(
  ({ children: t, className: o, ...r }, n) => /* @__PURE__ */ e(
    le,
    {
      "data-testid": "flexContainer",
      ref: n,
      className: o,
      display: "flex",
      ...r,
      children: t
    }
  )
), Dt = (t, o) => t && t in a.color ? a.color[t] : o, B = ({
  className: t,
  color: o,
  onClick: r,
  fixedWidth: n = !1,
  inverse: f = !1,
  listItem: i = !1,
  spin: d = !1,
  swapOpacity: u = !1,
  "data-testid": y,
  ...v
}) => {
  const g = Dt(o);
  return /* @__PURE__ */ e(
    xe,
    {
      className: t,
      color: g,
      "data-testid": y,
      fixedWidth: n,
      inverse: f,
      listItem: i,
      spin: d,
      swapOpacity: u,
      ...v
    }
  );
}, Ft = ({
  event: t,
  align: o = "start",
  timezone: r,
  tooltipPlacement: n
}) => {
  var g;
  const f = (t == null ? void 0 : t.variant) === "filled", i = t.icon ? t.icon : null, d = Intl.DateTimeFormat("en-US", {
    timeZone: r || Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }).format(t == null ? void 0 : t.start), u = `${t.title}, ${d}`, y = /* @__PURE__ */ W(Zt, { className: "rbc-event-title", children: [
    t.title,
    ", ",
    d
  ] }), v = n ? /* @__PURE__ */ e(
    gt,
    {
      title: ((g = t == null ? void 0 : t.tooltipProps) == null ? void 0 : g.title) || u,
      placement: n,
      children: y
    }
  ) : y;
  return /* @__PURE__ */ W(I, { title: "", alignItems: o, gap: 0.5, "data-testid": t.title, children: [
    i ? /* @__PURE__ */ e(B, { icon: i, color: f ? "white" : t.color }) : null,
    /* @__PURE__ */ e("div", { className: "rbc-title-wrapper", children: v })
  ] });
}, Sn = ({
  event: t,
  timezone: o,
  tooltipPlacement: r
}) => /* @__PURE__ */ e(
  Ft,
  {
    align: "center",
    event: t,
    timezone: o,
    tooltipPlacement: r
  }
), kn = ({
  initialDate: t,
  initialViewMode: o = "month",
  onRangeChange: r,
  onViewChange: n
}) => {
  const [f, i] = ht(t), [d, u] = ht(o), [y, v] = ht(o);
  o !== y && (v(o), u(o));
  const g = {
    day: "d",
    week: "w",
    month: "M"
  }, x = (b) => {
    u(b), C(f, g[b]), n == null || n(b);
  }, C = (b, F) => {
    const D = ut(b).startOf(F).toDate(), A = ut(b).endOf(F).toDate();
    r == null || r({ start: D, end: A });
  };
  return {
    currentDate: f,
    viewMode: d,
    onChangeView: x,
    onMove: (b) => {
      if (b === "back") {
        const D = ut(f).subtract(1, g[d]).toDate();
        i(D), C(D, g[d]);
        return;
      }
      const F = ut(f).add(1, g[d]).toDate();
      i(F), C(F, g[d]);
    },
    onMoveToday: () => {
      const b = ut().toDate();
      i(b), C(b, g[d]);
    }
  };
};
function Mn(t, o) {
  const r = ut(o);
  switch (t) {
    case "week": {
      const n = r.clone().startOf("week"), f = r.clone().endOf("week");
      return `${n.format("MMMM DD")} - ${f.format(
        "DD, YYYY"
      )}`;
    }
    case "month":
      return r.format("MMMM, YYYY");
    case "day":
      return r.format("MMMM DD, YYYY");
    default:
      return "";
  }
}
const $n = ye(ut), ai = ({
  events: t,
  initialDate: o,
  initialViewMode: r = "month",
  height: n,
  selectable: f = !0,
  loading: i = !1,
  grow: d = !0,
  className: u,
  classes: y,
  onNavigate: v = () => {
  },
  onViewChange: g = () => {
  },
  onView: x = () => {
  },
  tooltipPlacement: C,
  timezone: k,
  onRangeChange: M,
  restricted: b = !1,
  ...F
}) => {
  const { isMobile: D } = pn(), { currentDate: A, viewMode: E, onChangeView: Z, onMove: O, onMoveToday: U } = kn({
    initialDate: o,
    initialViewMode: r,
    onRangeChange: M,
    onViewChange: g
  }), { containerClassName: Y = "", rootClassName: at = "" } = y ?? {}, et = Mn(E, A), T = D ? void 0 : C;
  return /* @__PURE__ */ W(
    "div",
    {
      className: L("rbc-calendar-container", Y, {
        grow: d,
        loading: i,
        restricted: b
      }),
      children: [
        /* @__PURE__ */ e(
          gn,
          {
            disabled: !!i,
            viewLabel: et,
            viewMode: E,
            onChangeView: Z,
            onMoveToday: U,
            onMove: O
          }
        ),
        /* @__PURE__ */ e(
          _e,
          {
            className: L(at, {
              "rbc-week-view": E === "week"
            }),
            localizer: $n,
            date: A,
            events: t,
            startAccessor: "start",
            view: E,
            onView: x,
            toolbar: !1,
            selectable: f,
            onNavigate: v,
            components: {
              day: {
                event: (S) => /* @__PURE__ */ e(
                  Ft,
                  {
                    ...S,
                    timezone: k,
                    tooltipPlacement: T
                  }
                )
              },
              week: {
                event: (S) => /* @__PURE__ */ e(
                  Ft,
                  {
                    ...S,
                    timezone: k,
                    tooltipPlacement: T
                  }
                )
              },
              month: {
                event: (S) => /* @__PURE__ */ e(
                  Sn,
                  {
                    ...S,
                    timezone: k,
                    tooltipPlacement: T
                  }
                )
              },
              eventWrapper: hn
            },
            endAccessor: "end",
            views: ["month", "week", "day"],
            style: { height: n },
            ...F
          }
        )
      ]
    }
  );
};
var H = /* @__PURE__ */ ((t) => (t.h1 = "h1", t.h2 = "h2", t.h3 = "h3", t.h4 = "h4", t.h5 = "h5", t.h6 = "h6", t.lead400 = "lead400", t.lead500 = "lead500", t.lead700 = "lead700", t.titleMd500 = "titleMd500", t.titleMd700 = "titleMd700", t.titleSm500 = "titleSm500", t.titleSm700 = "titleSm700", t.bodyMd400 = "bodyMd400", t.bodyMd500 = "bodyMd500", t.bodyMd600 = "bodyMd600", t.bodyMd700 = "bodyMd700", t.bodySm400 = "bodySm400", t.bodySm500 = "bodySm500", t.bodySm600 = "bodySm600", t.bodySm700 = "bodySm700", t.meta400 = "meta400", t.meta700 = "meta700", t.label = "label", t.tiny = "tiny", t.mono = "mono", t.cursive = "cursive", t.stat1 = "stat1", t.stat2 = "stat2", t.stat3 = "stat3", t.stat4 = "stat4", t.stat5 = "stat5", t.stat6 = "stat6", t))(H || {});
const Et = {
  lead: H.lead400,
  leadBold: H.lead700,
  titleMd: H.titleMd500,
  titleMdBold: H.titleMd700,
  titleSm: H.titleSm500,
  titleSmBold: H.titleSm700,
  bodyMd: H.bodyMd400,
  bodyMdBold: H.bodyMd700,
  bodySm: H.bodySm400,
  bodySmBold: H.bodySm700,
  meta: H.meta400,
  metaBold: H.meta700,
  // Deprecated variants
  body1: H.bodyMd400,
  body2: H.bodySm400,
  subtitle1: H.titleMd500,
  subtitle2: H.titleSm500,
  caption: H.label,
  overline: H.tiny,
  button: H.bodyMd400
}, Cn = a.color.font, Dn = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g, Ln = (t = "") => {
  const o = a.color[t];
  return Object.keys(a.color).includes(t) || Dn.test(String(o)) ? o : (t && console.warn(`Wrong color name '${t}' provided, using fallback color.`), Cn);
}, Wn = (t) => typeof t == "string" && document.createElement(t) instanceof HTMLUnknownElement ? "p" : t, zn = (t) => {
  const o = Object.keys(Et);
  return t in H ? t : o.includes(t) ? Et[t] : H.bodyMd500;
}, Tn = "_textWrapper_1bmn2_3", Bn = "_italic_1bmn2_9", Fn = "_bold_1bmn2_13", On = "_rebrand_1bmn2_18", Nn = "_underlined_1bmn2_22", yt = {
  textWrapper: Tn,
  italic: Bn,
  bold: Fn,
  rebrand: On,
  underlined: Nn
}, st = mt.forwardRef(
  ({
    className: t,
    color: o,
    component: r = "p",
    isBold: n,
    isItalic: f,
    isRebrand: i,
    isRebrandUnderlined: d,
    testId: u,
    variant: y = "bodyMd600",
    ...v
  }, g) => {
    const x = zn(
      y
    );
    return /* @__PURE__ */ e(
      se,
      {
        ref: g,
        "data-testid": u,
        sx: { color: Ln(o) },
        className: L(t, yt[x], {
          [yt.italic]: f,
          [yt.bold]: n,
          [yt.rebrand]: i,
          [yt.underlined]: d
        }),
        variant: x,
        component: Wn(r),
        ...v
      }
    );
  }
), Rn = "_root_bokhp_1", Hn = {
  root: Rn
}, It = {
  approved: {
    label: "REGISTERED",
    textColor: "greenContrastDark",
    backgroundColor: "greenExtraLight",
    icon: ke,
    iconColor: "greenXtraDark"
  },
  requested: {
    label: "REQUEST PENDING",
    textColor: "orangeContrastDark",
    backgroundColor: "orangeExtraLight",
    icon: Se,
    iconColor: "orangeXtraDark"
  },
  rejected: {
    label: "REQUEST DECLINED",
    textColor: "redContrastDark",
    backgroundColor: "redExtraLight",
    icon: ve,
    iconColor: "redXtraDark"
  },
  removed: {
    label: "UNREGISTERED",
    textColor: "font",
    backgroundColor: "grayExtraLight",
    icon: we,
    iconColor: "grayXtraDark"
  }
}, An = ({ variant: t, label: o, icon: r }) => {
  if (!(t in It))
    return null;
  const {
    backgroundColor: n,
    label: f,
    icon: i,
    textColor: d,
    iconColor: u
  } = It[t];
  return /* @__PURE__ */ W(
    I,
    {
      alignItems: "center",
      className: Hn.root,
      sx: {
        p: 1,
        backgroundColor: Dt(n)
      },
      "data-testid": "card-cap",
      children: [
        /* @__PURE__ */ e(B, { icon: r || i, color: u, size: "xs" }),
        /* @__PURE__ */ e(st, { ml: 0.5, variant: "tiny", color: d, children: o || f })
      ]
    }
  );
}, En = "_root_154wt_1", In = "_shadow_154wt_45", jn = "_rounded_154wt_49", Wt = {
  root: En,
  shadow: In,
  rounded: jn
}, Xn = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "search",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
], Yn = (t) => Xn.includes(t), Un = (t) => t === void 0 ? "div" : typeof t == "string" ? Yn(t) ? t : "div" : t === Ct ? t : "div", Gn = (t) => t === "a" || t === "button" || Jt(t), Jt = (t) => t === Ct, Ot = mt.forwardRef(
  ({
    backgroundColor: t = "white",
    children: o,
    className: r = "",
    component: n = "div",
    href: f = "",
    onClick: i = () => null,
    shadow: d = !0,
    style: u = {},
    rounded: y = !0,
    width: v = "100%",
    newTab: g = !1,
    cardCapProps: x,
    "data-testid": C = "card",
    "aria-label": k
  }, M) => {
    const b = f && (wt(f) || g), F = !!x, D = Un(n), A = Gn(D), E = Jt(D), Z = F ? /* @__PURE__ */ W(I, { flexDirection: "column", children: [
      F && /* @__PURE__ */ e(An, { ...x }),
      o
    ] }) : o, O = {
      className: L(r, Wt.root, {
        [Wt.shadow]: d,
        [Wt.rounded]: y
      }),
      ref: M,
      style: {
        backgroundColor: Dt(
          t,
          a.color.grayDark
        ),
        width: v,
        ...u
      },
      "data-testid": C,
      "aria-label": k
    };
    return E ? mt.createElement(
      D,
      {
        ...O,
        onClick: i,
        rel: b ? "noreferrer" : void 0,
        target: b ? "_blank" : void 0,
        to: f
      },
      Z
    ) : mt.createElement(
      D,
      {
        ...O,
        ...A ? {
          onClick: i,
          rel: b ? "noreferrer" : void 0,
          target: b ? "_blank" : void 0,
          href: f
        } : {}
      },
      Z
    );
  }
), qn = "_root_caply_1", Zn = "_noPadding_caply_14", jt = {
  root: qn,
  noPadding: Zn
}, ii = mt.forwardRef(
  ({ children: t, removePadding: o = !1, ...r }, n) => /* @__PURE__ */ e(
    Me,
    {
      ref: n,
      disableRipple: !0,
      disableTouchRipple: !0,
      classes: {
        root: L(jt.root, { [jt.noPadding]: o })
      },
      ...r,
      children: t
    }
  )
), Jn = ({ size: t }) => t === "large" ? "bodySm400" : "meta400", Qn = ({ size: t, children: o }) => typeof o == "string" ? /* @__PURE__ */ e(st, { variant: Jn({ size: t }), children: o }) : /* @__PURE__ */ e(vt, { children: o }), Kn = "_container_1upjo_1", Vn = "_largeContainer_1upjo_14", Pn = "_mediumContainer_1upjo_23", tr = "_smallContainer_1upjo_32", er = "_warningContainer_1upjo_41", or = "_tipContainer_1upjo_49", nr = "_successContainer_1upjo_57", rr = "_errorContainer_1upjo_65", ar = "_pendingContainer_1upjo_73", ir = "_infoContainer_1upjo_81", lr = "_readOnlyContainer_1upjo_89", sr = "_clearIcon_1upjo_97", cr = "_dismissIcon_1upjo_104", Q = {
  container: Kn,
  largeContainer: Vn,
  mediumContainer: Pn,
  smallContainer: tr,
  warningContainer: er,
  tipContainer: or,
  successContainer: nr,
  errorContainer: rr,
  pendingContainer: ar,
  infoContainer: ir,
  readOnlyContainer: lr,
  clearIcon: sr,
  dismissIcon: cr
}, Xt = Object.freeze({
  tip: {
    className: Q.tipContainer,
    icon: /* @__PURE__ */ e(B, { icon: We })
  },
  warning: {
    className: Q.warningContainer,
    icon: /* @__PURE__ */ e(B, { icon: Te })
  },
  success: {
    className: Q.successContainer,
    icon: /* @__PURE__ */ e(B, { icon: $e })
  },
  error: {
    className: Q.errorContainer,
    icon: /* @__PURE__ */ e(B, { icon: ze })
  },
  pending: {
    className: Q.pendingContainer,
    icon: /* @__PURE__ */ e(B, { icon: Le })
  },
  info: {
    className: Q.infoContainer,
    icon: /* @__PURE__ */ e(B, { icon: Ce })
  },
  readOnly: {
    className: Q.readOnlyContainer,
    icon: /* @__PURE__ */ e(B, { icon: De })
  }
}), dr = Object.freeze({
  large: Q.largeContainer,
  medium: Q.mediumContainer,
  small: Q.smallContainer
}), li = ({
  containerClass: t = "",
  children: o,
  variant: r = "tip",
  size: n = "medium",
  className: f = "",
  customIcon: i = null,
  onDismiss: d = void 0
}) => {
  const u = d !== void 0;
  return /* @__PURE__ */ W(
    I,
    {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      className: L(
        f,
        Q.container,
        Xt[r].className,
        dr[n],
        t
      ),
      children: [
        u ? /* @__PURE__ */ e("div", {}) : null,
        /* @__PURE__ */ W(I, { alignItems: "center", children: [
          i || Xt[r].icon,
          /* @__PURE__ */ e(Qn, { size: n, children: o })
        ] }),
        u ? /* @__PURE__ */ e(
          Zt,
          {
            testId: "dismissIcon",
            "aria-label": "Dismiss",
            onClick: d,
            className: Q.dismissIcon,
            children: /* @__PURE__ */ e(B, { className: Q.clearIcon, icon: Be })
          }
        ) : null
      ]
    }
  );
}, fr = "_loadingIcon_raaev_1", ur = "_loadingOverlay_raaev_10", mr = "_coverParent_raaev_26", hr = "_casefileVariant_raaev_33", kt = {
  loadingIcon: fr,
  loadingOverlay: ur,
  coverParent: mr,
  casefileVariant: hr
}, si = ({
  className: t = "",
  iconColor: o,
  iconType: r = "line-scale",
  coverParent: n = !1,
  variant: f = "default",
  noFadeIn: i = !1,
  paperProps: d = {},
  ...u
}) => {
  const y = Dt(o, a.color.grayDark);
  return /* @__PURE__ */ e(
    Fe,
    {
      classes: {
        root: L(kt.loadingOverlay, t, n && kt.coverParent, {
          [kt.casefileVariant]: f === "casefile"
        })
      },
      "data-testid": "loading-overlay",
      ...d,
      children: /* @__PURE__ */ e(
        Gt,
        {
          className: kt.loadingIcon,
          name: r,
          color: y,
          fadeIn: i ? "none" : "half",
          ...u
        }
      )
    }
  );
}, ci = ({ children: t }) => /* @__PURE__ */ e(oe, { theme: Pe, children: t }), Qt = () => /* @__PURE__ */ W(I, { flexDirection: "column", width: "100%", children: [
  /* @__PURE__ */ e(V, { variant: "text", width: "25%" }),
  /* @__PURE__ */ e(V, { variant: "text", width: "75%" }),
  /* @__PURE__ */ e(V, { variant: "text", width: "60%" })
] }), gr = "_root_31ksi_1", br = {
  root: gr
}, pr = ({ "data-testid": t }) => /* @__PURE__ */ e(Ot, { className: br.root, "data-testid": t, children: /* @__PURE__ */ W(I, { columnGap: 1, children: [
  /* @__PURE__ */ e(V, { height: 40, width: 40, variant: "circular" }),
  /* @__PURE__ */ e(Qt, {})
] }) }), yr = "_root_31ksi_1", _r = {
  root: yr
}, xr = ({ "data-testid": t }) => /* @__PURE__ */ e(Ot, { className: _r.root, "data-testid": t, children: /* @__PURE__ */ e(Qt, {}) }), wr = ({ "data-testid": t }) => /* @__PURE__ */ W(I, { columnGap: 1, alignItems: "center", "data-testid": t, children: [
  /* @__PURE__ */ e(V, { height: 32, width: 32, variant: "circular" }),
  /* @__PURE__ */ e(V, { variant: "text", width: 80, height: 24 })
] }), vr = ({ "data-testid": t }) => /* @__PURE__ */ e(I, { justifyContent: "center", "data-testId": t, children: /* @__PURE__ */ e(Gt, { color: a.color.grayLight }) }), Sr = "_card_xgnkm_1", kr = "_metaData_xgnkm_5", Mr = "_errorMessage_xgnkm_10", zt = {
  card: Sr,
  metaData: kr,
  errorMessage: Mr
}, $r = ({
  errorMessage: t = "",
  "data-testid": o
}) => /* @__PURE__ */ e(Ot, { className: zt.card, "data-testid": o, children: /* @__PURE__ */ W(I, { flexDirection: "column", children: [
  t && /* @__PURE__ */ e(
    st,
    {
      component: "h3",
      variant: "titleSm700",
      color: "orangeDark",
      className: zt.errorMessage,
      children: t
    }
  ),
  /* @__PURE__ */ e(V, { height: 200, variant: "rectangular" }),
  /* @__PURE__ */ W(
    I,
    {
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: "0",
      className: zt.metaData,
      children: [
        /* @__PURE__ */ W(I, { columnGap: 1, alignItems: "center", flexGrow: 1, children: [
          /* @__PURE__ */ e(V, { width: 32, height: 32, variant: "circular" }),
          /* @__PURE__ */ W(I, { flexDirection: "column", flexGrow: 1, children: [
            /* @__PURE__ */ e(V, { height: 20, width: "75%" }),
            /* @__PURE__ */ e(V, { height: 20, width: "90%" })
          ] })
        ] }),
        /* @__PURE__ */ e(I, { alignItems: "center", justifyContent: "flex-end", flexGrow: 1, children: /* @__PURE__ */ e(V, { height: 40, width: "50%" }) })
      ]
    }
  )
] }) }), Cr = {
  listItem: pr,
  listItemText: xr,
  threeDots: vr,
  tableCellUser: wr,
  videoCard: $r
}, di = ({
  className: t = "",
  component: o = void 0,
  count: r = 1,
  "data-testid": n,
  ...f
}) => {
  const i = o ? Cr[o] : void 0;
  return Array(r).fill(0).map(
    (d) => i ? /* @__PURE__ */ e(i, { "data-testid": n }, d) : /* @__PURE__ */ e(
      V,
      {
        className: t,
        "data-testid": n,
        ...f
      },
      d
    )
  );
}, Dr = "_container_8swf9_1", Lr = "_dot_8swf9_12", Wr = "_red_8swf9_19", zr = "_dotOutlined_8swf9_27", Tr = "_gray_8swf9_33", Br = "_orange_8swf9_47", Fr = "_green_8swf9_61", Or = "_teal_8swf9_75", Nr = "_blue_8swf9_89", Rr = "_blueSteel_8swf9_103", Hr = "_yellow_8swf9_117", Ar = "_transparentBg_8swf9_132", _t = {
  container: Dr,
  dot: Lr,
  red: Wr,
  dotOutlined: zr,
  gray: Tr,
  orange: Br,
  green: Fr,
  teal: Or,
  blue: Nr,
  blueSteel: Rr,
  yellow: Hr,
  transparentBg: Ar
}, fi = ({
  className: t = "",
  color: o = "green",
  "data-testid": r,
  dot: n = !1,
  dotVariant: f = "filled",
  label: i,
  variant: d = "filled"
}) => {
  const u = _t[o === "blue-steel" ? "blueSteel" : o];
  return /* @__PURE__ */ W(
    I,
    {
      alignItems: "center",
      className: L(_t.container, u, t, {
        [_t.transparentBg]: d === "transparent"
      }),
      "data-testid": r,
      children: [
        n && /* @__PURE__ */ e(
          "div",
          {
            "data-testid": "status-lozenge-dot",
            className: L(_t.dot, {
              [_t.dotOutlined]: f === "outlined"
            })
          }
        ),
        /* @__PURE__ */ e("span", { children: i })
      ]
    }
  );
}, Er = ({
  showPassword: t,
  setShowPassword: o
}) => /* @__PURE__ */ e(Re, { position: "end", children: /* @__PURE__ */ e(
  gt,
  {
    placement: "top",
    title: t ? "Hide Password" : "Show Password",
    children: /* @__PURE__ */ e(
      Tt,
      {
        onClick: () => o(!t),
        color: "gray",
        hasIconRight: !0,
        icon: t ? /* @__PURE__ */ e(B, { icon: He, color: "gray" }) : /* @__PURE__ */ e(B, { icon: Ae, color: "gray" })
      }
    )
  }
) }), Ir = "_root_qg8p0_1", jr = "_fullWidth_qg8p0_5", Xr = "_outlinedInputRoot_qg8p0_9", Yr = "_rootLoading_qg8p0_17", Ur = "_rootWithStartAdornment_qg8p0_21", Gr = "_label_qg8p0_25", qr = "_helperTextBox_qg8p0_29", Zr = "_compactCharLimit_qg8p0_35", Jr = "_asterisk_qg8p0_46", Qr = "_hideNumberArrows_qg8p0_50", nt = {
  root: Ir,
  fullWidth: jr,
  outlinedInputRoot: Xr,
  rootLoading: Yr,
  rootWithStartAdornment: Ur,
  label: Gr,
  helperTextBox: qr,
  compactCharLimit: Zr,
  asterisk: Jr,
  hideNumberArrows: Qr
}, ui = mt.forwardRef(
  ({
    // MUI TextField base props
    variant: t = "outlined",
    rows: o = 5,
    InputLabelProps: r,
    // InputProps/inputProps must be explicitly defined here to prevent styling conflicts with MUI's default props
    InputProps: n,
    inputProps: f,
    // Character limit related props
    charLimit: i,
    enableHardLimit: d,
    // prevent user to input more characters than charLimit
    compactCharLimit: u,
    // transform charLimit styles so that it does not affect the layout
    hideNumberArrows: y,
    // Styling props
    outlinedInputClasses: v,
    rootClass: g,
    // Testing props
    testId: x,
    "data-testid": C,
    // State props
    loading: k,
    // Rest of TextField props
    value: M,
    ...b
  }, F) => {
    const [D, A] = ht(!1), E = "helper-text", Z = (M == null ? void 0 : M.length) || 0, O = i && Z > i, U = d ? (M || "").slice(0, i) : M, Y = k || !!(n != null && n.startAdornment), at = (n == null ? void 0 : n.type) === "password", et = k ? /* @__PURE__ */ e(
      B,
      {
        "data-testid": "loader-icon",
        spin: !0,
        icon: Oe,
        color: "gray"
      }
    ) : n == null ? void 0 : n.startAdornment, T = at ? /* @__PURE__ */ e(
      Er,
      {
        showPassword: D,
        setShowPassword: A
      }
    ) : n == null ? void 0 : n.endAdornment, S = () => b.defaultValue ? { defaultValue: b.defaultValue } : {}, it = {
      ...f,
      "data-testid": C || x,
      ...d && i ? { maxLength: i } : {},
      type: D ? "text" : n == null ? void 0 : n.type
    }, dt = L(nt.root, g, {
      [nt.rootWithStartAdornment]: Y,
      [nt.fullWidth]: b.fullWidth,
      [nt.rootLoading]: k,
      [nt.hideNumberArrows]: y && (n == null ? void 0 : n.type) === "number"
    }), p = () => !b.helperText && !i ? null : /* @__PURE__ */ W(vt, { children: [
      /* @__PURE__ */ e(st, { variant: "label", id: E, children: b.helperText }),
      i && /* @__PURE__ */ W(st, { variant: "label", children: [
        Z,
        "/",
        i
      ] })
    ] });
    return /* @__PURE__ */ e(
      Ne,
      {
        ...S(),
        "aria-describedby": b.helperText ? E : void 0,
        ref: F,
        rows: o,
        value: U,
        variant: t,
        disabled: k || b.disabled,
        error: !!(b.error || O),
        placeholder: k ? "loading" : b.placeholder,
        classes: {
          root: dt,
          ...b.classes
        },
        FormHelperTextProps: {
          classes: {
            root: L(nt.helperTextBox, {
              [nt.compactCharLimit]: u
            })
          }
        },
        InputLabelProps: {
          shrink: !0,
          classes: { root: nt.label, asterisk: nt.asterisk },
          ...r
        },
        InputProps: {
          ...n,
          startAdornment: et,
          endAdornment: T,
          classes: {
            ...v,
            root: L(nt.outlinedInputRoot, v == null ? void 0 : v.root)
          }
        },
        inputProps: it,
        helperText: p(),
        ...b
      }
    );
  }
), Kr = "_blueHover_1dzzk_6", Vr = "_underline_1dzzk_10", Yt = {
  blueHover: Kr,
  underline: Vr
}, mi = (t) => {
  const {
    href: o = "#",
    color: r = "blueXtraDark",
    children: n,
    className: f = "",
    forceUnderline: i = !1,
    forceDisableNewTab: d = !1
  } = t, u = wt(o) ? "a" : Ct, y = { [wt(o) ? "href" : "to"]: o };
  return /* @__PURE__ */ e(
    st,
    {
      color: r,
      className: L("textLink", f, {
        [Yt.blueHover]: r === "blueXtraDark",
        [Yt.underline]: i
      }),
      component: u,
      target: d ? "_self" : "_blank",
      rel: d ? void 0 : "noreferrer",
      ...t,
      ...y,
      children: n
    }
  );
}, Pr = "_paper_gwo6v_1", ta = "_popoverContainer_gwo6v_9", ea = "_arrow_gwo6v_14", oa = "_arrowBottom_gwo6v_25", na = "_arrowTop_gwo6v_32", ra = "_arrowLeft_gwo6v_39", aa = "_arrowRight_gwo6v_46", ia = "_anchorButton_gwo6v_52", la = "_bottom_gwo6v_58", sa = "_top_gwo6v_59", ca = "_left_gwo6v_63", da = "_right_gwo6v_64", fa = "_noArrow_gwo6v_68", ua = "_hoverable_gwo6v_73", ma = "_disabled_gwo6v_74", K = {
  paper: Pr,
  popoverContainer: ta,
  arrow: ea,
  arrowBottom: oa,
  arrowTop: na,
  arrowLeft: ra,
  arrowRight: aa,
  anchorButton: ia,
  bottom: la,
  top: sa,
  left: ca,
  right: da,
  noArrow: fa,
  hoverable: ua,
  disabled: ma
}, hi = ({
  anchorContent: t = () => /* @__PURE__ */ e("button", { type: "button", children: "Anchor" }),
  "aria-label": o,
  disabled: r = !1,
  disabledMessage: n = "Disabled",
  hideArrow: f = !1,
  hoverable: i = !1,
  messagePlacement: d = "top",
  onAnchorClick: u = () => null,
  onCloseCallback: y = () => null,
  paperClass: v,
  placement: g = "bottom",
  popoverContent: x = () => /* @__PURE__ */ e("div", {}),
  tooltipProps: C,
  ...k
}) => {
  const [M, b] = ht(null), F = re(null), D = {
    bottom: {
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      transformOrigin: { vertical: "top", horizontal: "center" }
    },
    top: {
      anchorOrigin: { vertical: "top", horizontal: "center" },
      transformOrigin: { vertical: "bottom", horizontal: "center" }
    },
    left: {
      anchorOrigin: { vertical: "center", horizontal: "left" },
      transformOrigin: { vertical: "center", horizontal: "right" }
    },
    right: {
      anchorOrigin: { vertical: "center", horizontal: "right" },
      transformOrigin: { vertical: "center", horizontal: "left" }
    }
  }, A = (Y) => {
    u(), b(M ? null : Y.currentTarget);
  }, E = () => {
    b(null), y();
  }, Z = (Y) => {
    i && b(Y.currentTarget);
  }, O = () => {
    i && (b(null), y());
  };
  return /* @__PURE__ */ W(vt, { children: [
    /* @__PURE__ */ e(
      gt,
      {
        title: !r && !(C != null && C.title) ? "" : (C == null ? void 0 : C.title) || n,
        placement: d,
        ...C,
        children: /* @__PURE__ */ e(
          "button",
          {
            "aria-expanded": !!M,
            "aria-label": o,
            "aria-owns": i && M ? "mouse-over-popover" : void 0,
            "aria-haspopup": "true",
            disabled: r,
            type: "button",
            onClick: A,
            onMouseEnter: Z,
            onMouseLeave: O,
            className: L(K.anchorButton, K[g], {
              [K.hoverable]: i,
              [K.noArrow]: f,
              [K.disabled]: r
            }),
            children: t({ disabled: r })
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      Ut,
      {
        sx: i ? { pointerEvents: "none" } : void 0,
        ...D[g],
        ...k,
        id: i ? "mouse-over-popover" : void 0,
        open: !!M,
        anchorEl: M,
        anchorReference: "anchorEl",
        onClose: E,
        disableRestoreFocus: i,
        disableEnforceFocus: i,
        classes: {
          paper: L(K.paper, v)
        },
        children: /* @__PURE__ */ W("div", { className: K.popoverContainer, children: [
          !f && /* @__PURE__ */ e(
            "span",
            {
              ref: F,
              className: L(K.arrow, {
                [K.arrowBottom]: g === "bottom",
                [K.arrowTop]: g === "top",
                [K.arrowLeft]: g === "left",
                [K.arrowRight]: g === "right"
              })
            }
          ),
          x({ setAnchor: b })
        ] })
      }
    )
  ] });
};
export {
  ni as Avatar,
  qt as Badge,
  Tt as Button,
  ai as Calendar,
  Ot as Card,
  An as CardCap,
  Zt as ClickableComponent,
  I as Flexbox,
  B as FontAwesomeIcon,
  ii as IconButton,
  li as InfoNote,
  si as LoadingOverlay,
  ci as MuiThemeProvider,
  di as Skeleton,
  fi as StatusLozenge,
  st as Text,
  ui as TextInput,
  mi as TextLink,
  gt as Tooltip,
  hi as WithPopover,
  je as camelCase,
  a as cssVars,
  ri as generateCssVarsPlugin,
  Ie as kebabCase,
  Pe as theme,
  pn as useMediaInfo
};
